module.exports = __webpack_public_path__ + "static/img/3.7db061b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Bukanga-Lonzo/3.jpg
// module id = 0Aid
// module chunks = 0